import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { SupplyPartnersRoute } from "./supplyPartners.routes";

type Props = {};

export function SupplyPartnersModule({}: Props): React.ReactElement {
  return (
    <Layout>
      {SupplyPartnersRoute.subRoutes && (
        <ModuleRouter subRoutes={SupplyPartnersRoute.subRoutes} path={SupplyPartnersRoute.path} />
      )}
    </Layout>
  );
}
